import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import MergerSubsDetailList from "containers/mergersubs/MergerSubsDetailList";
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class MergerSubListExport extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.exportRecords = this.exportRecords.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);

        this.state = {
            searching: false,
            isLoading: true,
            mergerSubs: [],
            mergerSubDetails: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            showDetailDialog: false,
            selectedCityscope: null,
            cityscopeOptions: [],
            cityscope: null,
            createdDateFrom: null,
            createdDateTo: null,
            appendix: null,
            index: null,
            mergersubid: null,
            selected: null ,
            typeOptions: [{value: "S", label: "Sub Division"},{value: "M", label: "Merger"}],
            sourceDestinationOptions: [{value: "S", label: "Source"},{value: "D", label: "Destination"}]

        };

        
    }
    

    async componentDidMount() {
        console.log("In MergerSubList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        await this.getCityscopes();

        const mergerSubs = await this.getMergerSubs({cityscope: this.state.cityscope
            });
        this.setState({ mergerSubs });
        
        

        document.title = "Mergers & Sub Divisions";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ mergerSubs: [] });        
    }

    async getMergerSubs(filter) {
        console.log("Inside getMergerSubs() ");
        
        return API.get("colin", "/mergersubs", { 'queryStringParameters': filter });
      
    }

    
    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    



    async sortMergerSubs (mergerSubs){
        mergerSubs.sort(function (a, b) { 
            if (a.CreatedDate===b.CreatedDate){ 
                return 0
            } 
            if(a.CreatedDate > b.CreatedDate ){return -1}else{return 1}
        });
        mergerSubs.sort(function (a, b) { 
            if (a.Cityscope===b.Cityscope){ 
                return 0
            } 
            if(a.Cityscope < b.Cityscope ){return -1}else{return 1}
        });
        return mergerSubs
    }

    handleSubmit = async event =>{
        event.preventDefault();
        this.setState({mergerSubDetails: []});
        try {
            let mergerSubs = await this.getMergerSubs({cityscope: this.state.cityscope
                                                    ,createdDateFrom: this.state.createdDateFrom ? Moment(this.state.createdDateFrom).local().format("YYYY-MM-DD"):""
                                                    ,createdDateTo: this.state.createdDateTo ? Moment(this.state.createdDateTo).local().format("YYYY-MM-DD"):""
                                                    });
            const sortedMergerSubs = await this.sortMergerSubs(mergerSubs)
            this.setState({ mergerSubs: sortedMergerSubs });
        } catch (e) {
            alert(e);
        }
    }
    
    handleInputChange = (cellInfo, event) => {
        
        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[cellInfo.index][cellInfo.column.id] = event.target.value;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});
    };
    handleNumberChange = (cellInfo, event) => {
        
        let mergerSubs = [...this.state.mergerSubs];
        let val = event.target.value.replace(/[^0-9]/g, "");        
        mergerSubs[cellInfo.index][cellInfo.column.id] = val;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[cellInfo.index][cellInfo.column.id] = event.target.checked;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});
       
    };


    handleDateChange(date, name) {
        if (date) {
            this.setState({
                [name]: new Date(date)
                , modified: true });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }



    handleCityscopeChange = async (selectedCityscope) => {
        if(selectedCityscope){
            
            this.setState({ selectedCityscope
                            ,cityscope: selectedCityscope.map(r=>r.value).join(",")
                            , modified: true },this.handleBlur)
        }else{
            this.setState({ selectedCityscope
                ,cityscope: ""
                , modified: true },this.handleBlur)
        }

    }

    validateRelatedRecord(record, set) {
      

        return [true,];
    }

    async handleDataSave(record,id) {
        console.log("In handleDataSave");
        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/mergersubs/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/mergersubs/${record.merger_sub_id}`, {
            body: record
        }
        );
    }

    handleSave = async (event) => {

        this.setState({ showAlert: false });
        

        let data = [...this.state.mergerSubs];
        for (var i=0; i<data.length; i++){
            
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        const validation = this.validateRelatedRecord(data[i], "mergerSubs");
                        console.log(validation[0]);
                        if (validation[0] === true) {
                            console.log(validation[0])
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i].merger_sub_id = result.id;
                                        this.setState({ savingNewRecord: false });  
                                        this.setState({index: 0, mergersubid: result.id});                                      

                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }
                    else {
                        this.setState({ errorMessage: validation[1] });
                        this.setState({ showAlert: true });
                    }
                    }
                    

                }
            
        }   
        // if (data[0].hasOwnProperty("sort_order")) {
        //     data.sort(function (a, b) { return a.sort_order - b.sort_order });
        // }
        this.setState({mergerSubs: data});


    }

   

    

    
    handleSelectRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("select record");
        let mergerSubs = [...this.state.mergerSubs];
        let mergerSub = mergerSubs[cellInfo.index];
        const mergerSubDetails = (mergerSub.mergersubs_list|| []);
        this.setState({index: cellInfo.index, mergersubid: mergerSub.merger_sub_id});
        this.setState({mergerSubDetails});
            
            
 
    };
    
    updateTableState(data) {
        
        this.setState({mergerSubDetails: data });

        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[this.state.index].mergersubs_list = data;
        this.setState({mergerSubs });
     
    }


    async exportRecords(event) {
        this.setState({ isLoading: true });  
        
        let mergersSubsExport= {}; 
        
        if(!this.state.createdDateFrom || !this.state.createdDateTo){
            alert("You must enter created date from and to before running an export");
            this.setState({ isLoading: false });
            return;
        }
        
        const typeMap = {
            'M': 'Merger',
            'S': 'Subdivision',
            'N': 'New Property',
            'R': 'Removed Property'
        };

        mergersSubsExport = this.state.mergerSubs.map((r)=>{return {'ID': r.merger_sub_id,
                                                                    'Cityscope': r.cityscope,
                                                                    'Appendix': r.appendix,
                                                                    'Type': typeMap[r.type],
                                                                    'CreatedDate': r.created_date? Moment(r.created_date).local().format("DD-MM-YYYY"):"",
                                                                    'As they were': r.mergersubs_list? r.mergersubs_list.reduce(function(filtered, prop) {
                                                                                                                                        if(prop.source_or_dest=== "S"){
                                                                                                                                            var k = prop.property_key;
                                                                                                                                            filtered.push(k);
                                                                                                                                        }
                                                                                                                                        return filtered;
                                                                                                                                        }
                                                                                                            ,[]).sort(function(a, b) {
                                                                                                                        var cityscopeA = a.toUpperCase().substring(0,1); // ignore upper and lowercase
                                                                                                                        var cityscopeB = b.toUpperCase().substring(0,1); // ignore upper and lowercase
                                                                                                                        if (cityscopeA < cityscopeB) {
                                                                                                                        return -1;
                                                                                                                        }
                                                                                                                        if (cityscopeA > cityscopeB) {
                                                                                                                        return 1;
                                                                                                                        }
                                                                                                                        return 0;
                                                                                                                    }).sort(function(a, b) {
                                                                                                                        var mapNoA = a.toUpperCase().substring(2,3); // ignore upper and lowercase
                                                                                                                        var mapNoB = b.toUpperCase().substring(2,3); // ignore upper and lowercase
                                                                                                                        if (mapNoA < mapNoB) {
                                                                                                                        return -1;
                                                                                                                        }
                                                                                                                        if (mapNoA > mapNoB) {
                                                                                                                        return 1;
                                                                                                                        }
                                                                                                                        return 0;
                                                                                                                    }).sort(function(a, b) {
                                                                                                                        var propertyNoA = a.toUpperCase().substring(6,7); // ignore upper and lowercase
                                                                                                                        var propertyNoB = b.toUpperCase().substring(6,7); // ignore upper and lowercase
                                                                                                                        if (propertyNoA < propertyNoB) {
                                                                                                                        return -1;
                                                                                                                        }
                                                                                                                        if (propertyNoA > propertyNoB) {
                                                                                                                        return 1;
                                                                                                                        }
                                                                                                                        return 0;
                                                                                                                    }).join("; "): "",
                                                                    'What they became': r.mergersubs_list? r.mergersubs_list.reduce(function(filtered, prop) {
                                                                                                                                                if(prop.source_or_dest=== "D"){
                                                                                                                                                    var k = prop.property_key;
                                                                                                                                                    filtered.push(k);
                                                                                                                                                }
                                                                                                                                                return filtered;
                                                                                                                                                }
                                                                                                                    ,[]).sort(function(a, b) {
                                                                                                                        var cityscopeA = a.toUpperCase().substring(0,1); // ignore upper and lowercase
                                                                                                                        var cityscopeB = b.toUpperCase().substring(0,1); // ignore upper and lowercase
                                                                                                                        if (cityscopeA < cityscopeB) {
                                                                                                                        return -1;
                                                                                                                        }
                                                                                                                        if (cityscopeA > cityscopeB) {
                                                                                                                        return 1;
                                                                                                                        }
                                                                                                                        return 0;
                                                                                                                    }).sort(function(a, b) {
                                                                                                                        var mapNoA = a.toUpperCase().substring(2,3); // ignore upper and lowercase
                                                                                                                        var mapNoB = b.toUpperCase().substring(2,3); // ignore upper and lowercase
                                                                                                                        if (mapNoA < mapNoB) {
                                                                                                                        return -1;
                                                                                                                        }
                                                                                                                        if (mapNoA > mapNoB) {
                                                                                                                        return 1;
                                                                                                                        }
                                                                                                                        return 0;
                                                                                                                    }).sort(function(a, b) {
                                                                                                                        var propertyNoA = a.toUpperCase().substring(6,7); // ignore upper and lowercase
                                                                                                                        var propertyNoB = b.toUpperCase().substring(6,7); // ignore upper and lowercase
                                                                                                                        if (propertyNoA < propertyNoB) {
                                                                                                                        return -1;
                                                                                                                        }
                                                                                                                        if (propertyNoA > propertyNoB) {
                                                                                                                        return 1;
                                                                                                                        }
                                                                                                                        return 0;
                                                                                                                    }).join("; "): "",
                                                                    'Description': r.description                                        
                                                                                                            
                                                                }});
        
        

        
        
        mergersSubsExport.sort(function (a, b) { 
            if (a.CreatedDate===b.CreatedDate){ 
                return 0
            } 
            if(a.CreatedDate > b.CreatedDate ){return -1}else{return 1}
        });
        mergersSubsExport.sort(function (a, b) { 
            if (a.Cityscope===b.Cityscope){ 
                return 0
            } 
            if(a.Cityscope < b.Cityscope ){return -1}else{return 1}
        });


        this.setState({ mergersSubsExport });
        var fromDt = new Date(this.state.createdDateFrom);
        var dd1 = fromDt.getDate();        
        var mm1 = fromDt.getMonth()+1; 
        var yy1 = fromDt.getFullYear();

        var toDt = new Date(this.state.createdDateTo);
        var dd2 = toDt.getDate();        
        var mm2 = toDt.getMonth()+1; 
        var yy2 = toDt.getFullYear();
        
        let fileName="";
        if(1===1){
            fileName = "CS_MS_"+yy1.toString()+("0"+mm1).slice(-2)+("0"+dd1).slice(-2)+"_to_"+yy2.toString()+("0"+mm2).slice(-2)+("0"+dd2).slice(-2)+".csv";
        }
        
        var csvFile = '';
        if(1===1){
            csvFile = ["ID","Cityscope","Appendix","Type","Created Date","As they were","What they became","Description"].join(",")+"\r\n" //
            csvFile = csvFile+mergersSubsExport.map(r => {return Object.values(r).map(x=> {
                if(x===null){
                    return ''
                }   
                else if (typeof x=== 'number') { return x}else{return "\""+x+"\""}}).join(","); }).join("\r\n"); 
        }
        
                                        
        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, fileName);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        this.setState({ isLoading: false });      

    } 


    

    
    renderTable(data) {
        const columns = [

            {
                id: 'merger_sub_id',
                Header: 'ID',
                maxWidth: 80,
                accessor: 'merger_sub_id' ,
                // Cell: row => <Button type="button" size="sm" variant="link" onClick={(e) => this.handleSelectRecord(row,e)}>{row.value}</Button>
        }
        , {
                id: 'cityscope',
                Header: 'Cityscope',            
                accessor: 'cityscope',
                // Cell: this.renderEditable,
                maxWidth: 100
                

            }, {
                id: 'appendix',
                Header: 'Appendix',            
                accessor: 'appendix',
                // Cell: this.renderEditable,
                maxWidth: 150

            }
            ,
            {
                id: 'type',
                Header: 'Type',            
                accessor: 'type',
                // Cell: this.renderEditable,
                maxWidth: 150

            }
            ,
            {
                id: 'description',
                Header: 'Description',            
                accessor: 'description',
                // Cell: this.renderEditable,
                maxWidth: 400

            } ,
            
            {
                id: 'created_date',
                Header: 'Created Date',
                maxWidth: 100,
                style: { textAlign: "center" },
                accessor: d => {
                    if (d.created_date) {
                        return Moment(d.created_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <Row><Col >
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}      
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                            onClick: (e) => {
                              this.setState({
                                selected: rowInfo.index
                              })
                              this.handleSelectRecord(rowInfo,e)
                            },
                            style: {
                              background: rowInfo.index === this.state.selected && rowInfo.original.merger_sub_id != null ? '#00afec' : 'white',
                              color: rowInfo.index === this.state.selected && rowInfo.original.merger_sub_id != null ? 'white' : 'black'
                            }
                          }
                        }else{
                          return {}
                        }
                      }
                    }                                              
                />
                </Col>

                </Row>
            )
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

   


    renderComponent() {
        return (
            <div className="mergersubs">
                
                            
                                
                        
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <form onSubmit={this.handleSubmit}>
                 <Row >
                     <Col  sm={2} md={2} lg={2}>
                     <Form.Group as={Row}  controlId="cityscope" >
                     
                        <Col>
                        <Select
                            value={this.state.selectedCityscope}
                            onChange={this.handleCityscopeChange}
                            options={this.state.cityscopeOptions}
                            // onInputChange={this.handleChange}
                            placeholder="Cityscope"
                            isMulti
                        />
                        </Col>


                    </Form.Group>
                    </Col>
                    <Col sm={6} md={6} lg={3}> 
                        <Form.Group as={Row}  controlId="createdDateFrom" >
                            <Form.Label column className="text-right">Created Date From</Form.Label>
                            <Col>
                                <DatePicker
                                    selected={this.state.createdDateFrom}
                                    onChange={e => this.handleDateChange(e, "createdDateFrom")}
                                    name="createdDateFrom"
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    isClearable={true}
                                />
                                </Col>
                        </Form.Group>

                        </Col>
                        <Col sm={6} md={6} lg={3}> 
                            <Form.Group as={Row}  controlId="createdDateTo" >
                                <Form.Label column className="text-right">Created Date To</Form.Label>
                                <Col>
                                    <DatePicker
                                        selected={this.state.createdDateTo}
                                        onChange={e => this.handleDateChange(e, "createdDateTo")}
                                        name="createdDateTo"
                                        
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        isClearable={true}
                                    /></Col>
                            </Form.Group>

                        </Col>
                     
                 
                        <Col sm={2} md={2} lg={2}>
                        <Button type="submit" variant="primary">Search</Button>
                        

                        </Col>

                        <Col className="text-right" sm={2} md={2} lg={2}>
                        <Button type="button"  variant="primary"  onClick={this.exportRecords} >Export File</Button>
                   
                        
                        </Col>
                        

                    </Row> 
                    </form>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.mergerSubs) : this.renderTable(this.state.mergerSubs)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="MergerList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
